import { TournamentFollow, TournamentFollowWithDetails } from '../../domain/models';

// Entity representing the database structure
export interface TournamentFollowEntity {
  id: string;
  user_id: string;
  tournament_id: string;
  created_at: string;
}

export interface TournamentFollowWithDetailsEntity extends TournamentFollowEntity {
  tournament_name?: string;
  tournament_description?: string;
  tournament_status?: string;
  tournament_type?: string;
  tournament_is_public?: boolean;
  tournament_max_participants?: number;
  tournament_start_date?: string;
  tournament_location?: string;
  follower_count?: number;
}

// Mapper: from Entity (DB) to Model (Domain)
export const tournamentFollowEntityToModel = (entity: TournamentFollowEntity): TournamentFollow => {
  return {
    id: entity.id,
    userId: entity.user_id,
    tournamentId: entity.tournament_id,
    createdAt: new Date(entity.created_at),
  };
};

export const tournamentFollowWithDetailsEntityToModel = (
  entity: TournamentFollowWithDetailsEntity
): TournamentFollowWithDetails => {
  return {
    id: entity.id,
    userId: entity.user_id,
    tournamentId: entity.tournament_id,
    createdAt: new Date(entity.created_at),
    tournamentName: entity.tournament_name,
    tournamentDescription: entity.tournament_description,
    tournamentStatus: entity.tournament_status,
    tournamentType: entity.tournament_type,
    tournamentIsPublic: entity.tournament_is_public,
    tournamentMaxParticipants: entity.tournament_max_participants,
    tournamentStartDate: entity.tournament_start_date ? new Date(entity.tournament_start_date) : undefined,
    tournamentLocation: entity.tournament_location,
    followerCount: entity.follower_count,
  };
};

// Mapper: from Model (Domain) to Entity (DB)
export const tournamentFollowModelToEntity = (
  model: Partial<TournamentFollow>
): Partial<TournamentFollowEntity> => {
  return {
    id: model.id,
    user_id: model.userId,
    tournament_id: model.tournamentId,
    created_at: model.createdAt?.toISOString(),
  };
};
